import { PRODUCT } from '@/consts';

export const isVehicleDamageProduct = (productId?: number): boolean => {
  return (
    productId === PRODUCT.VEHICLE_DAMAGE ||
    productId === PRODUCT.VEHICLE_DAMAGE_TRANSPORT
  );
};
